// Configuration for Video Generation page actions and sample images

const CDN_BASE = "https://genres.nyc3.cdn.digitaloceanspaces.com/thumbnails/video_gen/images/";

export const videoActionsConfig = {
    reverse_cowgirl: {
        title: "Cowgirl",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "reverse_cowgirl",
        sampleImages: [
            {id: "sample_cowgirl_1", url: `${CDN_BASE}reverse_cowgirl1_thumbnail.jpg`},
            {id: "sample_cowgirl_2", url: `${CDN_BASE}reverse_cowgirl2_thumbnail.jpg`},
            {id: "sample_cowgirl_3", url: `${CDN_BASE}reverse_cowgirl3_thumbnail.jpg`},
            {id: "sample_cowgirl_4", url: `${CDN_BASE}reverse_cowgirl4_thumbnail.jpg`},
        ]
    },
    blowjob: {
        title: "Blowjob",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "blowjob",
        sampleImages: [
            {id: "sample_blowjob_1", url: `${CDN_BASE}blowjob1_thumbnail.jpg`},
            {id: "sample_blowjob_2", url: `${CDN_BASE}blowjob2_thumbnail.jpg`},
            {id: "sample_blowjob_3", url: `${CDN_BASE}blowjob3_thumbnail.jpg`},
            {id: "sample_blowjob_4", url: `${CDN_BASE}blowjob4_thumbnail.jpg`},
        ]
    },
    cumshot: {
        title: "Cumshot",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "cumshot",
        sampleImages: [
            {id: "sample_cumshot_1", url: `${CDN_BASE}cumshot1_thumbnail.jpg`},
            {id: "sample_cumshot_2", url: `${CDN_BASE}cumshot2_thumbnail.jpg`},
            {id: "sample_cumshot_3", url: `${CDN_BASE}cumshot3_thumbnail.jpg`},
            {id: "sample_cumshot_4", url: `${CDN_BASE}cumshot4_thumbnail.jpg`},
        ]
    },
    fingering: {
        title: "Fingering",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "fingering",
        sampleImages: [
            {id: "sample_fingering_1", url: `${CDN_BASE}fingering1_thumbnail.jpg`},
            {id: "sample_fingering_2", url: `${CDN_BASE}fingering2_thumbnail.jpg`},
            {id: "sample_fingering_3", url: `${CDN_BASE}fingering3_thumbnail.jpg`},
            {id: "sample_fingering_4", url: `${CDN_BASE}fingering4_thumbnail.jpg`},
        ]
    },
    fisting: {
        title: "Fisting",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "fisting",
        sampleImages: [
            {id: "sample_fisting_1", url: `${CDN_BASE}fisting1_thumbnail.jpg`},
            {id: "sample_fisting_2", url: `${CDN_BASE}fisting2_thumbnail.jpg`},
            {id: "sample_fisting_3", url: `${CDN_BASE}fisting3_thumbnail.jpg`},
            {id: "sample_fisting_4", url: `${CDN_BASE}fisting4_thumbnail.jpg`},
        ]
    },
    full_nelson: {
        title: "Full Nelson",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "full_nelson",
        sampleImages: [
            {id: "sample_full_nelson_1", url: `${CDN_BASE}full_nelson1_thumbnail.jpg`},
            {id: "sample_full_nelson_2", url: `${CDN_BASE}full_nelson2_thumbnail.jpg`},
            {id: "sample_full_nelson_3", url: `${CDN_BASE}full_nelson3_thumbnail.jpg`},
            {id: "sample_full_nelson_4", url: `${CDN_BASE}full_nelson4_thumbnail.jpg`},
        ]
    },
    posing: {
        title: "Posing",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "posing",
        sampleImages: [
            {id: "sample_posing_1", url: `${CDN_BASE}posing1_thumbnail.jpg`},
            {id: "sample_posing_2", url: `${CDN_BASE}posing2_thumbnail.jpg`},
            {id: "sample_posing_3", url: `${CDN_BASE}posing3_thumbnail.jpg`},
            {id: "sample_posing_4", url: `${CDN_BASE}posing4_thumbnail.jpg`},
        ]
    },
    pov_insertion: {
        title: "POV Insertion",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "pov_insertion",
        sampleImages: [
            {id: "sample_pov_insertion_1", url: `${CDN_BASE}pov_insertion1_thumbnail.jpg`},
            {id: "sample_pov_insertion_2", url: `${CDN_BASE}pov_insertion2_thumbnail.jpg`},
            {id: "sample_pov_insertion_3", url: `${CDN_BASE}pov_insertion3_thumbnail.jpg`},
            {id: "sample_pov_insertion_4", url: `${CDN_BASE}pov_insertion4_thumbnail.jpg`},
        ]
    },
    rimming: {
        title: "Rimming",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "rimming",
        sampleImages: [
            {id: "sample_rimming_1", url: `${CDN_BASE}rimming1_thumbnail.jpg`},
            {id: "sample_rimming_2", url: `${CDN_BASE}rimming2_thumbnail.jpg`},
            {id: "sample_rimming_3", url: `${CDN_BASE}rimming3_thumbnail.jpg`},
            {id: "sample_rimming_4", url: `${CDN_BASE}rimming4_thumbnail.jpg`},
        ]
    },
    show_feet: {
        title: "Show Feet",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "show_feet",
        sampleImages: [
            {id: "sample_show_feet_1", url: `${CDN_BASE}show_feet1_thumbnail.jpg`},
            {id: "sample_show_feet_2", url: `${CDN_BASE}show_feet2_thumbnail.jpg`},
            {id: "sample_show_feet_3", url: `${CDN_BASE}show_feet3_thumbnail.jpg`},
            {id: "sample_show_feet_4", url: `${CDN_BASE}show_feet4_thumbnail.jpg`},
        ]
    },
    titfuck: {
        title: "Titfuck",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "titfuck",
        sampleImages: [
            {id: "sample_titfuck_1", url: `${CDN_BASE}titfuck1_thumbnail.jpg`},
            {id: "sample_titfuck_2", url: `${CDN_BASE}titfuck2_thumbnail.jpg`},
            {id: "sample_titfuck_3", url: `${CDN_BASE}titfuck3_thumbnail.jpg`},
            {id: "sample_titfuck_4", url: `${CDN_BASE}titfuck4_thumbnail.jpg`},
        ]
    },
    twerking: {
        title: "Twerking",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "twerking",
        sampleImages: [
            {id: "sample_twerking_1", url: `${CDN_BASE}twerking1_thumbnail.jpg`},
            {id: "sample_twerking_2", url: `${CDN_BASE}twerking2_thumbnail.jpg`},
            {id: "sample_twerking_3", url: `${CDN_BASE}twerking3_thumbnail.jpg`},
            {id: "sample_twerking_4", url: `${CDN_BASE}twerking4_thumbnail.jpg`},
        ]
    },
    titfuck_anime: {
        title: "Titfuck",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "titfuck_anime",
        sampleImages: [
            {id: "sample_titfuck_1", url: `${CDN_BASE}titfuck_anime1_thumbnail.jpg`},
            {id: "sample_titfuck_2", url: `${CDN_BASE}titfuck_anime2_thumbnail.jpg`},
            {id: "sample_titfuck_3", url: `${CDN_BASE}titfuck_anime3_thumbnail.jpg`},
            {id: "sample_titfuck_4", url: `${CDN_BASE}titfuck_anime4_thumbnail.jpg`},
        ]
    },
    blowjob_anime: {
        title: "Blowjob",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "blowjob_anime",
        sampleImages: [
            {id: "sample_blowjob_1", url: `${CDN_BASE}blowjob_anime1_thumbnail.jpg`},
            {id: "sample_blowjob_2", url: `${CDN_BASE}blowjob_anime2_thumbnail.jpg`},
            {id: "sample_blowjob_3", url: `${CDN_BASE}blowjob_anime3_thumbnail.jpg`},
            {id: "sample_blowjob_4", url: `${CDN_BASE}blowjob_anime4_thumbnail.jpg`},
        ]
    },
    twerking_anime: {
        title: "Twerking",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "twerking_anime",
        sampleImages: [
            {id: "sample_twerking_1", url: `${CDN_BASE}twerking_anime1_thumbnail.jpg`},
            {id: "sample_twerking_2", url: `${CDN_BASE}twerking_anime2_thumbnail.jpg`},
            {id: "sample_twerking_3", url: `${CDN_BASE}twerking_anime3_thumbnail.jpg`},
            {id: "sample_twerking_4", url: `${CDN_BASE}twerking_anime4_thumbnail.jpg`},
        ]
    },
    posing_anime: {
        title: "Posing",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "posing_anime",
        sampleImages: [
            {id: "sample_posing_1", url: `${CDN_BASE}posing_anime1_thumbnail.jpg`},
            {id: "sample_posing_2", url: `${CDN_BASE}posing_anime2_thumbnail.jpg`},
            {id: "sample_posing_3", url: `${CDN_BASE}posing_anime3_thumbnail.jpg`},
            {id: "sample_posing_4", url: `${CDN_BASE}posing_anime4_thumbnail.jpg`},
        ]
    },
    full_nelson_anime: {
        title: "Full Nelson",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "full_nelson_anime",
        sampleImages: [
            {id: "sample_full_nelson_1", url: `${CDN_BASE}full_nelson_anime1_thumbnail.jpg`},
            {id: "sample_full_nelson_2", url: `${CDN_BASE}full_nelson_anime2_thumbnail.jpg`},
            {id: "sample_full_nelson_3", url: `${CDN_BASE}full_nelson_anime3_thumbnail.jpg`},
            {id: "sample_full_nelson_4", url: `${CDN_BASE}full_nelson_anime4_thumbnail.jpg`},
        ]
    },
    reverse_cowgirl_anime: {
        title: "Reverse Cowgirl",
        subtitle: "Choose photo from our gallery or create custom photo",
        action: "reverse_cowgirl_anime",
        sampleImages: [
            {id: "sample_reverse_cowgirl_1", url: `${CDN_BASE}reverse_cowgirl_anime1_thumbnail.jpg`},
            {id: "sample_reverse_cowgirl_2", url: `${CDN_BASE}reverse_cowgirl_anime2_thumbnail.jpg`},
            {id: "sample_reverse_cowgirl_3", url: `${CDN_BASE}reverse_cowgirl_anime3_thumbnail.jpg`},
            {id: "sample_reverse_cowgirl_4", url: `${CDN_BASE}reverse_cowgirl_anime4_thumbnail.jpg`},
        ]
    }
};

export const defaultVideoAction = {
    title: "Video Generation",
    subtitle: "Choose photo from our gallery or create custom photo",
    action: "reverse_cowgirl",
    sampleImages: []
};
